import React, { useState } from 'react';
import { DataGrid, GridColDef, GridToolbarContainer } from '@mui/x-data-grid';
import { useGridApiContext } from "@mui/x-data-grid";
import { Button, Grid, Tooltip, Fade, ListItemIcon, Menu, MenuItem, InputBase, InputAdornment, IconButton } from "@mui/material";
import { Download, Print } from '@mui/icons-material';
import { Icons } from '../Icons';

interface CustomState {
  [key: string]: boolean
}

const TablePaginateUsers = (
  { rowsInfo,
    columns,
    asignarEnlaces,
    selectedOptions,
    Mostrar,
    loading,
    checkboxActive,
    exportFile,
    camposCsv,
    pageSize,
    handleSearch,
    searchTerm
  }:
    {
      rowsInfo: any,
      columns: GridColDef[],
      asignarEnlaces: Function,
      selectedOptions: CustomState,
      Mostrar: boolean,
      loading: boolean,
      checkboxActive: boolean,
      exportFile?: boolean,
      camposCsv?: string[],
      pageSize: number,
      setPageSize?: Function,
      handleSearch?: Function,
      searchTerm?: string
    }) => {

  const customLocaleText = {
    noRowsLabel: 'No se encontraron resultados',
    noResultsOverlayLabel: 'Resultados no encontrados',
    MuiTablePagination: {
      labelDisplayedRows: ({ from, to, count }: { from: any, to: any, count: any }) =>
        `${from} - ${to} de ${count}`,
      getItemAriaLabel: (type: any) => {
        if (type === 'first') {
          return 'Primera página';
        }
        if (type === 'last') {
          return 'Última página';
        }
        if (type === 'next') {
          return 'Página siguiente';
        }
        // if (type === 'previous') {
        return 'Página anterior';
      },
      labelRowsPerPage: 'Registros:',
      toolbar: {
        searchTooltip: 'Buscar…',
      },
    },
    footerRowSelected: (count: any) =>
      count > 1
        ? `${count.toLocaleString()} filas seleccionadas`
        : `${count.toLocaleString()} fila seleccionada`,
  };

  function CustomToolbar() {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    // const camposCsv = [ "Nombre","Descripcion"];
    const [searchInput, setSearchInput] = useState("");
    const handleChange = (event: any) => {
      setSearchInput(event.target.value);
      if (event.target.value === '' && handleSearch) {
        handleSearch("")
      }
    };
    const handleKeyDown = (event: any) => {
      if (event.key === 'Enter' && handleSearch) {
        handleSearch(event.target.value);
      }
    };
    const apiRef = useGridApiContext();
    const handleExport = () => { apiRef.current.exportDataAsCsv({ fields: camposCsv, utf8WithBom: true }); handleClose() }
    const handlePrint = () => { apiRef.current.exportDataAsPrint({ fields: camposCsv }); handleClose() }
    const clearSeach = () => {
      if (handleSearch) {
        handleSearch("");
      }
    }
    return (
      <GridToolbarContainer sx={{ display: "flex", justifyContent: "space-between" }} hidden={exportFile ? false : true}>
        <Button
          color="inherit"
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          disabled={exportFile ? false : true}
        >
          {exportFile ? "Exportar" : ""}
        </Button>
        <Menu
          MenuListProps={{ 'aria-labelledby': 'fade-button', }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem onClick={handleExport}>
            <ListItemIcon>
              <Download fontSize="small" />
            </ListItemIcon>
            Descarga CSV
          </MenuItem>
          <MenuItem onClick={handlePrint}>
            <ListItemIcon>
              <Print fontSize="small" />
            </ListItemIcon>
            Imprimir PDF
          </MenuItem>
        </Menu>
        {
          handleSearch &&
          <InputBase placeholder="Buscar…"
            id="filled-adornment-weight"
            value={searchInput !== "" ? searchInput : searchTerm}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            startAdornment={<InputAdornment position="start">{Icons("Search")}</InputAdornment>}
            aria-describedby="filled-weight-helper-text"
            inputProps={{
              'aria-label': 'weight',
            }}
            endAdornment={
              <InputAdornment position="end">
                {(searchInput !== "" || searchTerm !== "") &&
                  <IconButton onClick={clearSeach}>{Icons("Close")}</IconButton >
                }
              </InputAdornment>
            }
          />
        }
      </GridToolbarContainer>
    );
  }

  // const [isLoading, setIsLoading] = React.useState(false);

  return (
    <>
      <Grid item xs={12}>
        <Grid style={{ height: 700, width: '100%' }}>
          <DataGrid
            sx={{
              type: "number",
              align: "left"
            }}
            components={{ Toolbar: CustomToolbar }}
            rows={rowsInfo}
            columns={columns}
            loading={loading}
            pageSize={pageSize}
            checkboxSelection={checkboxActive}
            getRowId={(row: any) => row.Id}
            localeText={customLocaleText}
            disableColumnMenu
          />
        </Grid>
        <br />
        <Tooltip title="Asignar enlaces">
          <Button
            color="primary"
            variant="contained"
            style={{
              position: 'absolute',
              //bottom: '50px', // Ajusta la distancia desde la parte inferior
              right: '50px',  // Ajusta la distancia desde la derecha
              display: Mostrar ? 'block' : 'none', // Usar 'block' para mostrar y 'none' para ocultar
              textTransform: 'capitalize'
            }}
            onClick={() => {
              // Tu función onClick aquí
              asignarEnlaces(selectedOptions);
            }}
          >
            Asignar
          </Button>
        </Tooltip>
        <br />
      </Grid>

    </>
  );
};

export { TablePaginateUsers };